import {SectionFormSchema} from '@/modules/sections/schemas'
import {getAddressFieldsDefaultValues, type Address} from '@cypro/ui/components/form/address/utils'
import {SelectItem} from '@cypro/ui/components/form/select'
import {Section} from '@cypro/engine/schema'

export function getDefaultSectionFormValues(
  section: Section | undefined,
  defaultAddress?: Partial<Address>
): SectionFormSchema {
  return {
    name: section?.name || '',
    code: section?.code || '',
    costCenterNumber: section?.costCenterNumber || '',
    orderNumber: section?.orderNumber || '',
    movementType: section?.movementType || '',
    address: getAddressFieldsDefaultValues(section?.address, defaultAddress),
  }
}

export function mapSectionsToSelectItems(sections: Section[]): SelectItem[] {
  return sections.map(section => ({...section, label: `${section.code} - ${section.name}`, value: section.id}))
}

export function isSectionDeletable(section: Section) {
  const hasActiveWards = Boolean(section.wards?.some(w => w.status === 'active'))

  return !hasActiveWards
}
